import apiClient from './api'
import type { ApiResponse } from '@/types'

// A single global-search hit. `ref` is the in-app route to navigate to.
export interface SearchResult {
  id: string
  label: string
  subtitle: string | null
  ref: string
}

// Backend entity-type discriminators (snake_case), one group per entity.
export type SearchEntityType =
  | 'clients'
  | 'jobs'
  | 'quotes'
  | 'invoices'
  | 'credit_notes'
  | 'contracts'
  | 'technicians'
  | 'tasks'
  | 'payments'

export interface SearchGroup {
  entity_type: SearchEntityType
  results: SearchResult[]
}

export interface GlobalSearchData {
  groups: SearchGroup[]
}

// 2.13.1 - global search across every entity the user may access.
export const searchApi = {
  global: (q: string) =>
    apiClient
      .get<ApiResponse<GlobalSearchData>>('/search', { params: { q } })
      .then(r => r.data),
}

export default searchApi
